module.exports = __webpack_public_path__ + "static/media/qr-code.f16d1715.png";